<div>
  <ion-icon class="px" name="filter-outline"></ion-icon>
  Filter
</div>
<ng-container *ngFor="let muscleGroup of muscleGroups">
  <ion-chip
    [class.chip-active]="toggleStates.get(muscleGroup.group)"
    [ngStyle]="toggleStates.get(muscleGroup.group) ? {'background': muscleGroup.color} : {}"
    [style.border-color]="muscleGroup.color"
    [outline]="true"
    (click)="toggleChipGroup(muscleGroup)">
      {{muscleGroup.group}}
  </ion-chip>
</ng-container>
